module.exports = __webpack_public_path__ + "static/media/Norbi Update Low Carb kakaoitalpor.651830cb.jpg";